import { GridCellProps } from '@progress/kendo-react-grid';
import { useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import PopUp from 'src/components/design-system/PopUp';
import { getBgColor, getIcon } from 'src/utils/icons';
import {
  amountGreater,
  amountLess,
  percentageGreater,
  percentageLess,
} from '../useViewInvoiceBudgetTableErrors';

const filterGLTotalZeroMessages = (messages: string[] | undefined, isGLTotalZero: boolean) => {
  if (!isGLTotalZero) {
    return messages;
  }

  return messages?.filter(
    (message) => ![percentageLess, percentageGreater, amountGreater, amountLess].includes(message)
  );
};

const InvoiceBudgetPeriodWarning = (props: GridCellProps) => {
  const { dataItem } = props;
  const isGLTotalZero = dataItem.glTotal === 0;
  const warningMessages: string[] = useMemo(
    () => filterGLTotalZeroMessages(dataItem?.warnings, isGLTotalZero) || [],
    [dataItem?.warnings, isGLTotalZero]
  );
  const infoMessages: string[] = useMemo(
    () => filterGLTotalZeroMessages(dataItem?.infos, isGLTotalZero) || [],
    [dataItem?.infos, isGLTotalZero]
  );
  const errorMessages: string[] = useMemo(() => dataItem?.errors || [], [dataItem?.errors]);

  return (
    <GridCellBase
      {...props}
      className={`${getBgColor(errorMessages, warningMessages, infoMessages)} overflow-visible-imp`}
      disableToolTip
    >
      {errorMessages.length || warningMessages.length || infoMessages.length ? (
        <PopUp
          content={
            <div className="flex flex-col gap-2">
              <PopUpContentWrapper type="Error" contents={errorMessages} />
              <PopUpContentWrapper type="Warning" contents={warningMessages} />
              <PopUpContentWrapper type="Information" contents={infoMessages} />
            </div>
          }
        >
          <div className="flex justify-center items-center">
            {getIcon(errorMessages, warningMessages, infoMessages)}
          </div>
        </PopUp>
      ) : (
        ''
      )}
    </GridCellBase>
  );
};

export default InvoiceBudgetPeriodWarning;
